/**
 * Tabbed Features — tab switching with accessible keyboard navigation.
 */
(function () {
  document.querySelectorAll('[role="tablist"]').forEach(function(tablist) {
    var tabs = tablist.querySelectorAll('[role="tab"]');

    function activateTab(activeTab) {
      tabs.forEach(function(tab) {
        var isActive = tab === activeTab;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        tab.classList.toggle('is-active', isActive);
        tab.classList.toggle('twcss-border-current', isActive);
        tab.classList.toggle('twcss-font-semibold', isActive);
        tab.classList.toggle('twcss-border-transparent', !isActive);

        var panelId = tab.getAttribute('aria-controls');
        var panel = panelId && document.getElementById(panelId);
        if (panel) panel.hidden = !isActive;
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function(e) {
        var tabsArray = Array.from(tabs);
        var currentIndex = tabsArray.indexOf(tab);
        var newIndex;
        if (e.key === 'ArrowRight') {
          newIndex = (currentIndex + 1) % tabsArray.length;
        } else if (e.key === 'ArrowLeft') {
          newIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
        } else if (e.key === 'Home') {
          newIndex = 0;
        } else if (e.key === 'End') {
          newIndex = tabsArray.length - 1;
        } else { return; }
        e.preventDefault();
        activateTab(tabsArray[newIndex]);
        tabsArray[newIndex].focus();
      });
    });
  });
})();
